declare global {
  interface Window {
    _runtime_env_?: Record<string, string>;
  }
}

/**
 * Config variables can be supplied at runtime during PROD deployment though a `env-config.js` file that is loaded
 * from the `index.html`. This file, when executed will populate the `window._runtime_env_` (see `env-config.js` for shape example)
 *
 * But during development-time, this file will be empty, and we will instead use the values found in the process.env
 * (based on the contents of the .env file) as the source
 */
const envVarSource = window._runtime_env_ ?? process.env;

export const config = {
  appAdministrationBaseUrl:
    envVarSource.REACT_APP_APPLICATION_ADMINISTRATION_BASE_URL ??
    'MISSING_REACT_APP_APPLICATION_ADMINISTRATION_BASE_URL',

  accessManagementBaseUrl:
    envVarSource.REACT_APP_ACCESS_MANAGEMENT_BASE_URL ??
    'MISSING_REACT_APP_ACCESS_MANAGEMENT_BASE_URL',

  authBaseUrl:
    envVarSource.REACT_APP_AUTH_BASE_URL ?? 'MISSING_REACT_APP_AUTH_BASE_URL',

  axAuthAdminBaseUrl:
    envVarSource.REACT_APP_AX_AUTH_ADMIN_BASE_URL ??
    'MISSING_REACT_APP_AX_AUTH_ADMIN_BASE_URL',

  axAuthOidcBaseUrl:
    envVarSource.REACT_APP_AX_AUTH_OIDC_BASE_URL ??
    'MISSING_REACT_APP_AX_AUTH_OIDC_BASE_URL',

  portalServiceAdminBaseUrl:
    envVarSource.REACT_APP_PORTAL_SERVICE_ADMIN_BASE_URL ??
    'MISSING_REACT_APP_PORTAL_SERVICE_ADMIN_BASE_URL',

  userServiceAdminBaseUrl:
    envVarSource.REACT_APP_USER_SERVICE_ADMIN_BASE_URL ??
    'MISSING_REACT_APP_USER_SERVICE_ADMIN_BASE_URL',

  userServiceAuthBaseUrl:
    envVarSource.REACT_APP_USER_SERVICE_AUTH_BASE_URL ??
    'MISSING_REACT_APP_USER_SERVICE_AUTH_BASE_URL',

  hostingServiceAdminBaseUrl:
    envVarSource.REACT_APP_HOSTING_SERVICE_ADMIN_BASE_URL ??
    'MISSING_REACT_APP_HOSTING_SERVICE_ADMIN_BASE_URL',

  axinomProductSupportBaseUrl:
    envVarSource.REACT_APP_AXINOM_PRODUCT_SUPPORT_BASE_URL ??
    'AXINOM_PRODUCT_SUPPORT_BASE_URL',

  evaluationExpirationDuration: parseInt(
    envVarSource.REACT_APP_EVALUATION_EXPIRATION_IN_DAYS ?? '0',
  ),

  expirationWarningDuration: parseInt(
    envVarSource.REACT_APP_EVALUATION_EXPIRATION_WARNING_DURATION_IN_DAYS ??
      '0',
  ),

  evaluationExpirationExtensionInDays: parseInt(
    envVarSource.REACT_APP_EVALUATION_EXPIRATION_EXTENSION_IN_DAYS ?? '0',
  ),

  axinomPortalBaseUrl:
    envVarSource.REACT_APP_AXINOM_PORTAL_BASE_URL ??
    'MISSING_REACT_APP_AXINOM_PORTAL_BASE_URL',

  videoServiceBaseUrl:
    envVarSource.REACT_APP_VIDEO_SERVICE_ADMIN_BASE_URL ??
    'MISSINGREACT_APP_VIDEO_SERVICE_ADMIN_BASE_URL',

  imageServiceBaseUrl:
    envVarSource.REACT_APP_IMAGE_SERVICE_ADMIN_BASE_URL ??
    'MISSING_REACT_APP_IMAGE_SERVICE_ADMIN_BASE_URL',

  defaultSignInMethod:
    envVarSource.REACT_APP_DEFAULT_SIGN_IN_METHOD ??
    'MISSING_REACT_APP_DEFAULT_SIGN_IN_METHOD',

  cacheClearTimestamp: parseInt(
    envVarSource.REACT_APP_CACHE_CLEAR_TIMESTAMP ?? '0',
  ),

  managedServicesAvailableForUse: (
    envVarSource.REACT_APP_MANAGED_SERVICES_AVAILABLE_FOR_USE ??
    'MISSING_REACT_APP_MANAGED_SERVICES_AVAILABLE_FOR_USE'
  )
    .split(',')
    .map((serviceId) => serviceId.trim()),

  localizationServiceAdminBaseUrl:
    envVarSource.REACT_APP_LOCALIZATION_SERVICE_BASE_URL ??
    'MISSING_REACT_APP_LOCALIZATION_SERVICE_BASE_URL',

  serviceDeploymentEnabled: (): boolean =>
    envVarSource.REACT_APP_FEAT_HOSTING_V3?.toLowerCase() === 'enabled',
};
